export default async function getScreenBase64(map) {
    return new Promise(resolve => {
        map.once("rendercomplete", () => {
            if (!(map === null || map === void 0 ? void 0 : map.isRendered())) {
                resolve(undefined);
                return;
            }
            const mapCanvas = document.createElement("canvas");
            const size = map.getSize();
            if (size) {
                mapCanvas.width = size[0];
                mapCanvas.height = size[1];
            }
            const mapContext = mapCanvas.getContext("2d");
            Array.prototype.forEach.call(map.getViewport().querySelectorAll(".ol-layer canvas, canvas.ol-layer"), canvas => {
                if (canvas.width > 0) {
                    if (!mapContext)
                        return;
                    const opacity = canvas.parentNode.style.opacity || canvas.style.opacity;
                    mapContext.globalAlpha = opacity === "" ? 1 : Number(opacity);
                    let matrix;
                    const { transform } = canvas.style;
                    if (transform) {
                        matrix = transform
                            .match(/^matrix\(([^(]*)\)$/)[1]
                            .split(",")
                            .map(Number);
                    }
                    else {
                        matrix = [
                            parseFloat(canvas.style.width) / canvas.width,
                            0,
                            0,
                            parseFloat(canvas.style.height) / canvas.height,
                            0,
                            0
                        ];
                    }
                    CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
                    const { backgroundColor } = canvas.parentNode.style;
                    if (backgroundColor) {
                        mapContext.fillStyle = backgroundColor;
                        mapContext.fillRect(0, 0, canvas.width, canvas.height);
                    }
                    mapContext.drawImage(canvas, 0, 0);
                }
            });
            if (mapContext) {
                mapContext.globalAlpha = 1;
                mapContext.setTransform(1, 0, 0, 1, 0, 0);
                resolve(mapCanvas.toDataURL());
            }
            else {
                resolve(undefined);
            }
        });
        map.renderSync();
    });
}
